import React, { useState, useEffect } from 'react'
import Row from 'react-bootstrap/Row'
import Col from 'react-bootstrap/Col'
import Button from 'react-bootstrap/Button'
import Table from 'react-bootstrap/Table'
import { PanelFooter, PanelHeader } from 'components/Panel'

import { Offcanvas } from 'react-bootstrap'
import { getFileData } from 'utils/general'

function VerInformacionPublica(props) {
	const { informacion, setQueMostrar } = props

	const handleClose = () => {
		setQueMostrar('')
	}

	const fileData = getFileData(informacion.documento?.url)

	// render
	return (
		<Offcanvas show={true} onHide={handleClose} placement="end" scroll="true">
			<PanelHeader onClick={handleClose} iconClass="fa-arrow-left" btnText="Atrás" text="Ver información pública" />
			<Offcanvas.Body>
				<h1>Datos de la información pública</h1>
				<Row>
					<Col sm={12} md={6}>
						<Table>
							<thead></thead>
							<tbody>
								<tr>
									<th>Id</th>
									<td>{informacion.id}</td>
								</tr>
								<tr>
									<th>Nombre</th>
									<td>{informacion.nombre}</td>
								</tr>
								<tr>
									<th>Grupo</th>
									<td>{informacion.grupo}</td>
								</tr>
								<tr>
									<th>Orden</th>
									<td>{informacion.orden || '-'}</td>
								</tr>
                                <tr>
									<th>Documento</th>
									<td><i className={fileData.icono}></i> <a href={process.env.REACT_APP_API_URL + 'uploads/' + informacion.documento.url}>{fileData.nombre}</a></td>
								</tr>
							</tbody>
						</Table>
					</Col>
				</Row>
			</Offcanvas.Body>
			<PanelFooter>
				<Button variant="primary" onClick={handleClose}>
					Ok
				</Button>
			</PanelFooter>
		</Offcanvas>
	)
}

export default VerInformacionPublica